export class UploadData {
    Title: string;
	Text: string;
	ResizeMethod: string;
	TargetLibraryId: number;
	VoiceTalentId: number;
	LetterboxSize?: string

	constructor(resizeMethod?: string) {this.ResizeMethod = resizeMethod;}
}